import React from "react";
import { Upload, Button } from "antd";
import type { UploadFile } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { migrationApiUrl } from "../lib/env";

type MigrationFileUploaderProps = {
  defaultFiles?: UploadFile<any>[];
  onUploadComplete?: (
    file: UploadFile<any>,
  ) => boolean | void | Promise<boolean | void>;
  onFileRemoved?: (
    file: UploadFile<any>,
  ) => boolean | void | Promise<boolean | void>;
  onChange?: (
    file: UploadFile<any>,
  ) => boolean | void | Promise<boolean | void>;
  onUploadsInProgress?: (files: UploadFile<any>[]) => void;
  onNoUploadsInProgress?: () => void;
};

export class MigrationFileUploader extends React.Component<MigrationFileUploaderProps> {
  state = {};

  uploadFileUrl = async (file: UploadFile): Promise<any> => {
    const url = new URL(migrationApiUrl);
    url.pathname = "s3/sign";
    url.searchParams.append("objectName", file.name);
    url.searchParams.append("contentType", file.type);
    return await fetch(url.toString())
      .then((response) => response.json())
      .then((result) => {
        return result;
      });
  };

  onRemove = (file: UploadFile): boolean => {
    if (this.props.onFileRemoved) {
      if (file.response) {
        file.url = file.response.url;
      }
      this.props.onFileRemoved(file);
    }
    return true;
  };

  getACLFromSignedUrl = (signedUrl: string): string => {
    var acl: string;
    try {
      acl = new URL(signedUrl).searchParams.get("x-amz-acl");
    } finally {
      return acl || "public-read";
    }
  };
  customRequest = async (options: any) => {
    const { file, onError, onProgress, onSuccess } = options;
    const uploadFileUrl = await this.uploadFileUrl(file);
    var acl = this.getACLFromSignedUrl(uploadFileUrl.signedUrl);

    axios
      .request({
        method: "put",
        url: uploadFileUrl.signedUrl,
        data: file,
        headers: {
          "x-amz-acl": acl,
          "Access-Control-Allow-Origin": "*",
        },
        onUploadProgress: (p) => {
          onProgress(
            {
              percent: Math.round((p.loaded / p.total) * 100),
            },
            file,
          );
        },
      })
      .then((response) => {
        response["url"] = uploadFileUrl.url;
        onSuccess(response, file);
      })
      .catch((err) => {
        onError(err);
      });
  };

  onChange = ({ file, fileList }) => {
    if (this.props.onChange) {
      this.props.onChange(file);
    }

    if (file.status === "done") {
      if (this.props.onUploadComplete) {
        file.url = file.response.url;
        this.props.onUploadComplete(file);
      }
    }

    const filesUploading = fileList.filter(
      (file) => file.status === "uploading",
    );
    if (filesUploading.length > 0 && this.props.onUploadsInProgress) {
      this.props.onUploadsInProgress(filesUploading);
    } else if (this.props.onNoUploadsInProgress) {
      this.props.onNoUploadsInProgress();
    }
  };

  defaultFiles = (): UploadFile<any>[] => {
    if (this.props.defaultFiles) {
      return this.props.defaultFiles.map((file: any) => {
        return {
          name: file.filename,
          uid: file.url,
          size: 10000,
          type: "any",
          status: "done",
        };
      });
    } else {
      return [];
    }
  };

  render() {
    const defaultFiles = this.defaultFiles();
    const props = {
      defaultFileList: defaultFiles,
      customRequest: this.customRequest,
      onRemove: this.onRemove,
      onChange: this.onChange,
      multiple: true,
    };

    return (
      <div>
        <Upload {...props} method="PUT">
          <Button>
            <UploadOutlined /> Upload
          </Button>
        </Upload>
      </div>
    );
  }
}
